// Remote-control key that re-pairs the screen (Stop on Samsung/LG remotes).
export const RESET_KEY_CODE = 413;

// Hosts without a usable Stop key (e.g. Fire TV) dispatch this window event instead.
export const RESET_EVENT = 'pixelplay:reset';
